import React, {useEffect, useState} from 'react';
import Headline from './Headline';
import Grid from '@material-ui/core/Grid';
import {useUtilInformation} from 'components/hooks';
import CoursesStatus from './CoursesStatus';
import useLoadPendingCourse from 'features/dashboard/hooks/useLoadPendingCourse';

const ProgressCourses = () => {
  const {cwid} = useUtilInformation();
  const status = {
    notStarted: 0,
    inProgress: 2,
    finished: 1,
  };

  const notStartedDataSource = useLoadPendingCourse(cwid, status.notStarted);
  const inProgressDataSource = useLoadPendingCourse(cwid, status.inProgress);
  const finishedDataSource = useLoadPendingCourse(cwid, status.finished);

  const [notStartedCount, setNotStartedCount] = useState(0);
  const [inProgressCount, setInProgressCount] = useState(0);
  const [finishedCount, setFinishedCount] = useState(0);

  useEffect(() => {
    notStartedDataSource
      .totalCount()
      .then((count) => setNotStartedCount(count));

    inProgressDataSource
      .totalCount()
      .then((count) => setInProgressCount(count));

    finishedDataSource.totalCount().then((count) => setFinishedCount(count));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid item lg={8} md={8} sm={12} xs={12}>
      <Headline
        courseCount={{
          notStarted: notStartedCount,
          inProgress: inProgressCount,
          finished: finishedCount,
        }}
      />
      <CoursesStatus
        cwid={cwid}
        status={status}
        courseCount={{
          notStarted: notStartedCount,
          inProgress: inProgressCount,
          finished: finishedCount,
        }}
      />
    </Grid>
  );
};

export default ProgressCourses;
